import App from "./PrivacyPolicy";
import { createApp } from "vue";
import router from "../../router/index";
import VueAxios from 'vue-axios'
import axios from 'axios'

import store  from "../../store/stroe_policy";
store.commit('change', 'zh')
createApp(App).use(VueAxios, axios).use(router).use(store).mount("#app");
